import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bulma'
import 'ion-sound'

import axios from 'axios';

window.api = axios.create({
  // timeout : 3000,
	baseURL: process.env.VUE_APP_API
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
